import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { CustomButton } from '../commonComponents';

type iProps = {
    isInfoModal: boolean,
    toggleInfoModal: () => void,
    informationHtml: any,
    popupMinHeight?: string | number,
    modalHeader?: string,
    customModalHeaderStyle?: string,
}

const InfoModal: React.FC<iProps> = ({ isInfoModal, toggleInfoModal, informationHtml, popupMinHeight, modalHeader, customModalHeaderStyle }) => {

    return (
        <Modal
            isOpen={isInfoModal}
            toggle={toggleInfoModal}
            backdrop={true}
            centered={true}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
        >
            {modalHeader ? <ModalHeader className={customModalHeaderStyle}>{modalHeader}</ModalHeader> : null}
            <ModalBody style={{ minHeight: popupMinHeight }}>
                {informationHtml()}
            </ModalBody>
            <ModalFooter>
                <CustomButton text="Ok" color="primary" onClick={toggleInfoModal} />
            </ModalFooter>
        </Modal>
    )
}

export default InfoModal;